module.exports = {
  "auth": {
    "user_pool_id": "ap-northeast-1_21rxCGmKQ",
    "aws_region": "ap-northeast-1",
    "user_pool_client_id": "77qf2dtj837lqhmeb91k7tindc",
    "identity_pool_id": "ap-northeast-1:1aef6317-1543-4616-8a1d-d740b92b8724",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "groups": [],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": false,
      "require_uppercase": false
    },
    "oauth": {
      "identity_providers": [],
      "redirect_sign_in_uri": [
        "http://localhost:8000/auth/callback",
        "https://YOUR_DOMAIN/auth/callback"
      ],
      "redirect_sign_out_uri": [
        "http://localhost:8000/",
        "https://YOUR_DOMAIN/"
      ],
      "response_type": "code",
      "scopes": [
        "phone",
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin"
      ],
      "domain": "3b26ad7f84bb82c078e4.auth.ap-northeast-1.amazoncognito.com"
    },
    "unauthenticated_identities_enabled": true
  },
  "version": "1.4",
  "custom": {
    "apiBaseUrl": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/",
    "userProfileTableName": "amplify-d1xpduofu4s6em-hosting-branch-93c4f5dd01-datastack876175BF-1XY3RWRHUT5U8-UserProfileTable61BB5480-171MMOQ9X6Z4Y",
    "userProfileGsiEmail": "gsi_email",
    "userProfileGsiLineId": "gsi_lineId",
    "propertyTableName": "amplify-d1xpduofu4s6em-hosting-branch-93c4f5dd01-datastack876175BF-1XY3RWRHUT5U8-PropertyTable0DBB5666-BAUATFBCMF38",
    "propertyGsiAll": "gsi_all_properties",
    "reportTableName": "amplify-d1xpduofu4s6em-hosting-branch-93c4f5dd01-datastack876175BF-1XY3RWRHUT5U8-ReportTable270236C0-1CDP4BF14F4X5",
    "lineLinkStateTableName": "amplify-d1xpduofu4s6em-hosting-branch-93c4f5dd01-datastack876175BF-1XY3RWRHUT5U8-LineLinkStateTable7C9D134D-I3T4D3YOBAOU",
    "endpoints": {
      "clients": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/clients",
      "users": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/users",
      "usersDelete": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/users/delete",
      "usersPut": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/users",
      "properties": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/properties",
      "reports": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/reports",
      "lineLinkStart": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/line/link/start",
      "lineLinkCallback": "https://agf3395iha.execute-api.ap-northeast-1.amazonaws.com/prod/line/link/callback"
    }
  }
}